



















































import { Component, Vue } from 'vue-property-decorator'
import { getAllFatherNodeForTree, findItemForTree } from '../../../utils/toolsForCommon'
import { CommonModule, UserModule } from '../../../store'
import { ElMessageComponent } from 'element-ui/types/message'
import { encode, decode } from 'js-base64'
@Component({
  name: 'CapitalShiftToAffirm',
  components: {
    'capital-shift-to-affirm-table': () => import('../../../components/capitalShiftToAffirmTable/index.vue'),
    'loading-container': () => import('../../../components/loading.vue')
  }
})
export default class CapitalShiftToAffirm extends Vue {
  public tableDetail: any = {}
  // 附件预览：
  public dialogVisibleForPreviewFile: boolean = false
  public dialogVisiblePreviewUrl: string = ''
  public dialogVisibleiframeShowFlag: boolean = false
  public loadingForInformationOverviewContent: boolean = false

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  get villagesAndTowns (): string {
    const fatherNodeForTree = getAllFatherNodeForTree(this.treeDataForOrganatizion, 'children', 'id', this.userInfo.organizationId)
    const villagesAndTownsId = fatherNodeForTree[fatherNodeForTree.length - 2]
    if (!villagesAndTownsId) return '- -'
    const villagesAndTownsRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', villagesAndTownsId)
    return villagesAndTownsRes && villagesAndTownsRes['name'] ? villagesAndTownsRes['name'] : '- -'
  }

  async mounted () {
    const capitalShiftToAffirmContainerHeaderInnerTextDOM = document.querySelector('.capital_shift_to_affirm_container_header_inner_text')
    const timerIdForCapitalShiftToAffirmContainerHeaderInnerTextDOM = setInterval(() => {
      capitalShiftToAffirmContainerHeaderInnerTextDOM.classList.add('animate__swing')
      setTimeout(() => {
        capitalShiftToAffirmContainerHeaderInnerTextDOM.classList.remove('animate__swing')
      }, 500)
    }, 3000)
    this.$once('hook:beforeDestroy', () => {
      timerIdForCapitalShiftToAffirmContainerHeaderInnerTextDOM && clearInterval(timerIdForCapitalShiftToAffirmContainerHeaderInnerTextDOM)
    })
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.getDetailInfo()
  }

  // 获取基础信息：
  async getDetailInfo (): Promise<ElMessageComponent | void> {
    try {
      const params = {
        orgId: this.userInfo.organizationId
      }
      this.loadingForInformationOverviewContent = true
      const { data: result } = await (this as any).$http.capitalInfo(params)
      this.loadingForInformationOverviewContent = false
      if (result.code !== 200) return this.$message.error(result.msg)
      const info = (result.data && result.data.length && result.data[0]) || {}
      this.tableDetail = info
      this.getCapitalReceiptDetail()
    } catch (err) {
      console.log(err)
    }
  }

  // 获取需要编辑的详情：
  async getCapitalReceiptDetail () {
    const { detail } = this.$route.query as any
    if (!detail) return
    const detailInfo = JSON.parse(decode(detail))
    this.tableDetail = detailInfo
  }

  // 预览：
  previewBtn (v) {
    let _that: any = this
    this.dialogVisibleForPreviewFile = true
    let previewUrl = _that.$previewURL + '/onlinePreview?url=' + encodeURIComponent(encode(v))
    this.dialogVisiblePreviewUrl = previewUrl
  }

  // 预览框打开的时候：
  dialogVisibleOpened () {
    let _that: any = this
    _that.dialogVisibleiframeShowFlag = false
    _that.$nextTick(() => {
      let iframeBox = document.querySelector('#iframeBoxOfdialogVisible')
      if ((iframeBox as any).attachEvent) {
        ;(iframeBox as any).attachEvent('onload', function () {
          _that.dialogVisibleiframeShowFlag = true
        })
      } else {
        ;(iframeBox as any).onload = function () {
          _that.dialogVisibleiframeShowFlag = true
        }
      }
      _that.dialogVisibleiframeShowFlag = true
    })
  }

  async submitForApplication () {
    try {
      const { predictMoneyOfShiftTo, moneyOfShiftTo, timeOfShiftTo, transferFile, bankBalanceFile } = this.$refs.refForCapitalShiftToAffirmTable as any
      if (!predictMoneyOfShiftTo) return this.$message.warning('请输入预计学期应缴金额')
      if (!moneyOfShiftTo) return this.$message.warning('请输入本次转入金额（元）')
      if (!timeOfShiftTo) return this.$message.warning('请选择转入时间')
      if (!transferFile) return this.$message.warning('请上传转入凭证')
      if (!bankBalanceFile) return this.$message.warning('请上传银行账户余额凭证')
      let params = {
        accountName: this.tableDetail.accountName,
        account: this.tableDetail.account,
        depositBank: this.tableDetail.depositBank,
        depositBankCode: this.tableDetail.depositBankCode,
        receivingAccountName: this.tableDetail.receivingAccountName,
        receivingAccount: this.tableDetail.receivingAccount,
        receivingDepositBank: this.tableDetail.receivingDepositBank,
        receivingDepositBankCode: this.tableDetail.receivingDepositBankCode,
        estimateAmount: predictMoneyOfShiftTo,
        transferAmount: moneyOfShiftTo,
        time: timeOfShiftTo,
        transferFile,
        bankBalanceFile,
        role: 'SCHOOL'
      }
      if (this.villagesAndTowns) {
        const villagesAndTownsRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'name', this.villagesAndTowns)
        params['town'] = villagesAndTownsRes['id']
      }
      params['school'] = this.userInfo.organizationId
      const idForUpdate = this.$route.query.id
      let api = 'capitalTransferInsert'
      let messageText = '资金转入确认表提交成功'
      if (idForUpdate) {
        Object.assign(params, {
          id: idForUpdate
        })
        api = 'capitalTransferUpdate'
        messageText = '资金转入确认表编辑成功'
      }
      const { data: result } = await (this as any).$http[api](params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      setTimeout(() => {
        this.$router.push({ name: 'CapitalShiftToHistoryOfSchool' })
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }
}
